import { gql } from '@apollo/client';

// Lightweight query for the search/filter page — only fetches years and sources.
export const GET_WATER_USE_WATER_SYSTEM_YEARS_AND_SOURCES = gql`
    query getWaterUseSystemYearsAndSources($pwsId: String!) {
        getWaterUseSystemInfo(pwsId: $pwsId) {
            yearsAndSources {
                years
                sources {
                    id
                    name
                }
            }
        }
    }
`;

// Fetches system info (name, sizingInfo, years/sources) in a single request.
export const GET_WATER_USE_WATER_SYSTEM_INFO = gql`
    query getWaterUseSystemInfo($pwsId: String!) {
        getWaterUseSystemInfo(pwsId: $pwsId) {
            systemName
            sizingInfo {
                engineerName
                ccaDate
                engReport
                fileNumber
                standardSet
                peakDayDemand
                averageAnnualDemand
                equalizationStorage
            }
            yearsAndSources {
                years
                sources {
                    id
                    name
                }
            }
        }
    }
`;

export const GET_WATER_USE_WATER_SYSTEM_ANNUAL_USE = gql`
    query getWaterUseSystemAnnualUse($pwsId: String!, $years: [Int!]!, $sources: [String!]) {
        getWaterUseSystemAnnualUse(pwsId: $pwsId, years: $years, sources: $sources) {
            SourceRecords {
                sourceId
                sourceName
                sourceStatus
                sourceType
                diversionType
                YearRecords {
                    recordYear
                    jan
                    feb
                    mar
                    apr
                    may
                    jun
                    jul
                    aug
                    sep
                    oct
                    nov
                    dec
                    total
                }
            }
            WaterUses {
                historyYear
                domesticUseACFT
                commercialUseACFT
                industrialUseACFT
                institutionalUseACFT
                totalUseACFT
                domesticUseGallons
                commercialUseGallons
                industrialUseGallons
                institutionalUseGallons
                totalUseGallons
                totalFromSourcesACFT
                totalWholesaleSourcesACFT
                totalReturnSourcesACFT
                nonRevenuePercent
                nonRevenueACFT
                nonRevenueGallons
            }
        }
    }
`;

// Fetches peak day and peak month demand in a single request.
export const GET_WATER_USE_WATER_SYSTEM_PEAK_DATA = gql`
    query getWaterUseSystemPeakData($pwsId: String!, $years: [Int!]!, $sources: [String!]) {
        getWaterUseSystemPeakData(pwsId: $pwsId, years: $years, sources: $sources) {
            peakDemand {
                historyYear
                peakDate
                peakDemandACFT
                peakDemandGallons
                peakUseInclude
                peakMeasurementType
                peakWholesaleVolumeACFT
                peakWholesaleVolumeGallons
            }
            peakMonthDemand {
                historyYear
                peakMonthDemandACFT
                peakMonthDemandGallons
                daysInMonth
                gallonsPerDay
            }
        }
    }
`;
